<div class="no-content-wrapper">
    <div class="no-content-tip" [ngStyle]="{'fontSize': fontSize}">
        {{tip || 'No Content Here...'}}
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/no.content.tip/no.content.component.html